<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FormItem',
})
</script>
<template>
  <Form.Item :colon="false" v-bind="$attrs">
    <template v-if="label" #label>
      <Title :help="labelHelp">{{ label }}</Title>
    </template>
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}" />
    </template>
  </Form.Item>
</template>

<script lang="ts" setup name="FormItem">
import { Form } from 'ant-design-vue'
import { Title } from '-/Common/Title'
defineProps<{
  label?: string
  labelHelp?: any
}>()
</script>
